import React from 'react'
import NavItem from './NavItem'
import { RiAlarmLine, RiCalendarCheckLine, RiCalendarScheduleLine, RiFileList3Line, RiPieChartLine, RiReceiptLine, RiShoppingBag3Line, RiTeamLine, RiTimeLine, RiWallet3Line } from 'react-icons/ri'
import { useNavigate } from 'react-router-dom';
import { usePermission } from '../hooks/usePermission';

const RestaurantMenu = ({page}) => {   
    const navigate = useNavigate();
    const { hasPageAccess } = usePermission();
  return (
    <>
    {hasPageAccess("restaurantinsight") && (<NavItem
      icon={<RiPieChartLine />}
      title="Insight"
      path="/restaurantDashboard"
      navigateTo={navigate}
      active={page === "Insight"}
      submenuPageId={"0"}
    />)}
    {hasPageAccess("dailypaymentsummary") && (<NavItem
      icon={<RiWallet3Line />}
      title="Daily Payment Summary"
      path="/payment-wise-summary"
      navigateTo={navigate}
      active={page === "Daily Payment Summary"}
      submenuPageId={"0"}
    />)}
    {hasPageAccess("hourlyproductsummary") && (<NavItem
      icon={<RiAlarmLine />}
      title="Hourly Product Summary"
      path="/hourly-product-wise-summary"
      navigateTo={navigate}
      active={page === "Hourly Product Summary"}
      submenuPageId={"0"}
    />)}
    {hasPageAccess("dailysalessummary") && (<NavItem
      icon={<RiShoppingBag3Line />}
      title="Daily Sales Summary"
      path="/sales-wise-summary"
      navigateTo={navigate}
      active={page === "Daily Sales Summary"}
      submenuPageId={"0"}
    />)}
    {hasPageAccess("dailyliveorderssummary") && (<NavItem
      icon={<RiFileList3Line />}
      title="Daily Live Orders Summary"
      path="/live-order-wise-summary"
      navigateTo={navigate}
      active={page === "Daily Live Orders Summary"}
      submenuPageId={"0"}
    />)}
    {hasPageAccess("dailytimewisesalessummary") && (<NavItem
      icon={<RiTimeLine  />}
      title="Daily Timewise Sales Summary"
      path="/time-wise-daily-summary"
      navigateTo={navigate}
      active={page === "Daily Timewise Sales Summary"}
      submenuPageId={"0"}
    />)}
    {hasPageAccess("monthwisesalessummary") && (<NavItem
      icon={<RiCalendarScheduleLine  />}
      title="Monthwise Sales Summary"
      path="/month-wise-summary"
      navigateTo={navigate}
      active={page === "Monthwise Sales Summary"}
      submenuPageId={"0"}
    />)}
    {hasPageAccess("daywisesalessummary") && (<NavItem
      icon={<RiCalendarCheckLine   />}
      title="Daywise Sales Summary"
      path="/day-wise-summary"
      navigateTo={navigate}
      active={page === "Daywise Sales Summary"}
      submenuPageId={"0"}
    />)}
    {hasPageAccess("dailyinvoicecountsummary") && (<NavItem
      icon={<RiReceiptLine   />}
      title="Daily Invoice Count Summary"
      path="/invoice-wise-summary"
      navigateTo={navigate}
      active={page === "Daily Invoice Count Summary"}
      submenuPageId={"0"}
    />)}
    {hasPageAccess("dailywaiterwisesummary") && (<NavItem
      icon={<RiTeamLine   />}
      title="Daily Waiterwise Summary"
      path="/waiter-wise-summary"
      navigateTo={navigate}
      active={page === "Daily Waiterwise Summary"}
      submenuPageId={"0"}
    />)}
    </>
  )
}

export default RestaurantMenu